import React, { ComponentProps, forwardRef } from 'react';

import { LegacySecondaryButton as SecondaryButton } from 'components/Button/LegacySecondaryButton';
import { IDEALIST_UTM_PARAMS } from 'utils/constants';
import { hasUTMParam, isExternalURL, pathWithParams } from 'utils/url';

export const SecondaryButtonLink = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ComponentProps<typeof SecondaryButton>
>( // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ({ href, ...props }, ref) => (
    <SecondaryButton
      href={
        isExternalURL(href) && !hasUTMParam(href)
          ? pathWithParams(href, IDEALIST_UTM_PARAMS)
          : href
      }
      as="a"
      type={null}
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
);
